export default "__VITE_ASSET__DMSE1yXj__"